import FlexBox from '@sharedComponents/FlexBox';
import Typography from '@sharedComponents/Typography';
import { useTranslation } from 'react-i18next';

import * as style from './style.module.css';

const TYPE_LABELS = {
    typology: 'Typology',
    domain: 'Domain',
    family: 'Family',
};

// id will be used later
// eslint-disable-next-line no-unused-vars
const TagCard = ({ id, type, label, motsCles, onClick }) => {
    const { t } = useTranslation();

    return (
        <div className={style.card} onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onClick()}>
            <FlexBox flexDirection="column" gap="xs">
                <span className={`${style.badge} ${style[type] ?? ''}`}>{t(TYPE_LABELS[type] ?? type)}</span>
                <Typography fontWeight="bold" fontSize="m" className={style.label}>
                    {label}
                </Typography>
                {motsCles && (
                    <Typography fontSize="xs" className={style.keywords}>
                        {motsCles}
                    </Typography>
                )}
            </FlexBox>
        </div>
    );
};

export default TagCard;
